const locale = require('./collaborationTask.i18n.json');

/*@ngInject*/
const CollaborationTaskEditorController = function ($scope, $rootScope, $uibModal, $stateParams,
                                                    $document, $window, $timeout, currentUserModel,
                                                    modalUtil, attachmentMediator, submissionTaskStatus,
                                                    collaborationMediator, attachmentUtil, loadingBarHandler,
                                                    authorizationConstants) {

    $scope.taskI18n = locale;

    function resetTaskViewModel() {
        let currentUser = $scope.getCurrentUser(),
            permissions = [],
            neededPermissions = [
                authorizationConstants.AUTHORIZATION_ADD_ATTACHMENTS,
                authorizationConstants.AUTHORIZATION_DELETE_ATTACHMENTS
            ];

        $scope.taskEditorViewModel = {
            task: {
                id: null,
                definition: null,
                assignedToId: null,
                assignedToFullName: '',
                assignedById: null,
                assignedByFullName: '',
                nextTask: false,
                priority: null,
                dueDate: null,
                reminderDueDate: null,
                receivedDate: moment(),
                notifyWhenPastDue: false,
                comments: null,
                status: null,
                shared: false,
                attachmentSummaries: null
            },
            originalValues: {},
            assignedToUser: null,
            assignedByUser: null,
            definition: null,
            priority: null,
            details: null,
            otherSummary: null,
            attachmentTagItems: [],
            showAttachmentList: false
        };

        $scope.taskEditorViewModel.isAgent = (currentUser.userType === 'Agent');
        $scope.taskEditorViewModel.task.assignedById = currentUser.userId;
        $scope.taskEditorViewModel.task.assignedByFullName = currentUser.firstName + ' ' + currentUser.lastName;
        $scope.canDisplayList = false;
        $scope.canCloseAttachmentList = true;

        if ($scope.taskEditorViewModel.isAgent) {
            $scope.taskEditorViewModel.task.assignedToId = currentUser.userId;
            $scope.taskEditorViewModel.task.assignedToFullName = currentUser.firstName + ' ' + currentUser.lastName;
            $scope.taskEditorViewModel.task.shared = true;
        }

        _.each(neededPermissions, function (neededPermission) {
            if (currentUserModel.hasAuthorization(neededPermission)) {
                permissions.push(neededPermission);
            }
        });
        $scope.taskEditorViewModel.permissions = permissions;
    }

    $scope.canAddAttachment = function () {
        return (_.includes($scope.taskEditorViewModel.permissions, authorizationConstants.AUTHORIZATION_ADD_ATTACHMENTS));
    };

    $scope.canDeleteAttachment = function () {
        return (_.includes($scope.taskEditorViewModel.permissions, authorizationConstants.AUTHORIZATION_DELETE_ATTACHMENTS));
    };

    function setAssignedTo(result) {
        if (_.isEmpty(result)) {
            return;
        }

        $scope.taskEditorViewModel.assignedToUser = result;
        $scope.taskEditorViewModel.task.assignedToFullName = result.name;
        $scope.taskEditorViewModel.task.assignedToId = result.id;
    }

    function setAssignedBy(result) {
        if (_.isEmpty(result)) {
            return;
        }

        $scope.taskEditorViewModel.assignedByUser = result;
        $scope.taskEditorViewModel.task.assignedByFullName = result.name;
        $scope.taskEditorViewModel.task.assignedById = result.id;
    }

    $scope.handleVisibleToAgentToggle = function () {
        $scope.taskEditorViewModel.task.shared = !$scope.taskEditorViewModel.task.shared;
    };

    $scope.handleSummaryChange = function () {
        if ($scope.taskEditorViewModel.definition.value !== 'Other') {
            $scope.taskEditorViewModel.task.definition = $scope.taskEditorViewModel.definition.value;
        } else {
            $scope.taskEditorViewModel.task.definition = null;
        }
        $scope.taskEditorViewModel.otherSummary = null;
    };

    $scope.handleSummaryDescriptionChange = function () {
        if ($scope.taskEditorViewModel.definition.value === 'Other' && $scope.taskEditorViewModel.otherSummary) {
            $scope.taskEditorViewModel.task.definition = 'Other::' + $scope.taskEditorViewModel.otherSummary;
        } else {
            $scope.taskEditorViewModel.task.definition = null;
        }
    };

    $scope.handleDetailsChange = function () {
        let taskDetails = _.get($scope.taskEditorViewModel, 'task.details'),
            originalTaskDetails = _.get($scope.taskEditorViewModel, 'originalValues.details');

        if (taskDetails !== originalTaskDetails) {
            $scope.taskEditorViewModel.originalValues.details = taskDetails;
        }
    };

    $scope.handlePriorityChange = function () {
        $scope.taskEditorViewModel.task.priority = $scope.taskEditorViewModel.priority.value;

    };

    $scope.handleDueDateChange = function (selectedDate) {
        let dueDate = (selectedDate) ? (moment(new Date(selectedDate)).startOf('minute').unix() * 1000) : null;
            eightAM = (selectedDate) ? moment(selectedDate).startOf('day').add(8, 'hours') : null;

        $scope.taskEditorViewModel.task.dueDate = dueDate;
        $scope.taskEditorViewModel.task.reminderDueDate = (eightAM) ? (moment(eightAM).unix() * 1000) : 0;
    };

    $scope.handleReminderDateChange = function (selectedDate) {
        let reminderDate = (selectedDate) ? (moment(new Date(selectedDate)).startOf('minute').unix() * 1000) : null;
        $scope.taskEditorViewModel.task.reminderDueDate = reminderDate;
    };

    $scope.handleReceivedDateChange = function (selectedDate) {
        let receivedDate = (selectedDate) ? (moment(new Date(selectedDate)).startOf('minute').unix() * 1000) : null;
        $scope.taskEditorViewModel.task.receivedDate = receivedDate;
    };

    $scope.handleReminderEmailClick = function () {
        $scope.taskEditorViewModel.task.notifyWhenPastDue = !$scope.taskEditorViewModel.task.notifyWhenPastDue;
    };

    $scope.handleNextTaskClick = function () {
        $scope.taskEditorViewModel.task.nextTask = !$scope.taskEditorViewModel.task.nextTask;
    };

    $scope.handleAssignToChange = function () {
        if ($scope.taskEditorViewModel.assignedToUser) {
            if ($scope.taskEditorViewModel.assignedToUser.group === 'User Groups') {
                $scope.taskEditorViewModel.task.assignedToId = null;
                $scope.taskEditorViewModel.task.assignedToFullName = null;
                $scope.taskEditorViewModel.task.assignedToGroupId = $scope.taskEditorViewModel.assignedToUser.id;
                $scope.taskEditorViewModel.task.assignedToGroupName = $scope.taskEditorViewModel.assignedToUser.name;
            } else {
                $scope.taskEditorViewModel.task.assignedToId = $scope.taskEditorViewModel.assignedToUser.id;
                $scope.taskEditorViewModel.task.assignedToFullName = $scope.taskEditorViewModel.assignedToUser.name;
                $scope.taskEditorViewModel.task.assignedToGroupId = null;
                $scope.taskEditorViewModel.task.assignedToGroupName = null;
            }
        } else {
            $scope.taskEditorViewModel.task.assignedToId = null;
            $scope.taskEditorViewModel.task.assignedToFullName = null;
            $scope.taskEditorViewModel.task.assignedToGroupId = null;
            $scope.taskEditorViewModel.task.assignedToGroupName = null;
        }
        if (!$scope.taskEditorViewModel.assignedToUser.roles) {
            $scope.getUserRoles($scope.taskEditorViewModel.assignedToUser);
        }
    };

    $scope.handleAssignTask = function () {
        let task = {
            definition: $scope.taskEditorViewModel.task.definition,
            assignedToId: $scope.taskEditorViewModel.task.assignedToId,
            assignedToGroupId: $scope.taskEditorViewModel.task.assignedToGroupId,
            assignedById: $scope.taskEditorViewModel.task.assignedById,
            dueDate: $scope.taskEditorViewModel.task.dueDate,
            reminderDueDate: $scope.taskEditorViewModel.task.reminderDueDate,
            notifyWhenPastDue: $scope.taskEditorViewModel.task.notifyWhenPastDue,
            receivedDate: $scope.taskEditorViewModel.task.receivedDate,
            nextTask: $scope.taskEditorViewModel.task.nextTask,
            priority: $scope.taskEditorViewModel.task.priority,
            comments: $scope.taskEditorViewModel.task.comments,
            shared: $scope.taskEditorViewModel.task.shared,
            status: submissionTaskStatus.ASSIGNED,
            attachments: $scope.taskEditorViewModel.attachmentTagItems,
            details: $scope.taskEditorViewModel.task.details
        };
        $scope.createTask(task);
        $scope.hideTasksSubPage();
    };

    $scope.onAttachmentListClick = function (event) {
        $scope.canCloseAttachmentList = false;
    };

    $scope.openAttachmentList = function (event) {
        if ($scope.taskEditorViewModel.attachmentSummaries.length > 0) {
            $scope.canDisplayList = !$scope.canDisplayList;
            addListeners();
        } else {
            $scope.handleAttachmentClick();
        }
    };

    $scope.handleAttachmentClick = function () {
        var instance = $uibModal.open({
            templateUrl: '/collaboration/task/newTaskAttachmentModal/newTaskAttachmentModal.tpl.html',
            controller: 'newTaskAttachmentModalController',
            backdrop: 'static',
            windowClass: 'newTaskAttachmentModal',
            resolve: {
                options: function () {
                    return {};
                },
                isUnderwriterUser: !$scope.taskEditorViewModel.isAgent
            }
        });
        instance.result.then(function (data) {
            var payload = attachmentUtil.getAttachmentPayload(data.attachment);
            payload = _.assign(payload, {
                'ownerUri': 'com.firstbest.underwriting.submission.Submission:' + $stateParams.submissionId,
                'submissionId': $stateParams.submissionId
            });

            attachmentMediator.saveAttachment(payload, data.file).then(function (payload) {
                payload.attachment.checked = true;
                $scope.taskEditorViewModel.attachmentSummaries.push(payload.attachment);
                $scope.taskEditorViewModel.attachmentTagItems.push(payload.attachment);
            }.bind(this));

        });
    };

    $scope.onAttachmentItemClick = function (event, attachment) {
        if (attachment.checked) {
            $scope.taskEditorViewModel.attachmentTagItems.push(attachment);
        } else {
            _.pull($scope.taskEditorViewModel.attachmentTagItems, attachment);
        }
    };

    $scope.onDeleteTag = function (attachmentTag) {
        _.each($scope.taskEditorViewModel.attachmentSummaries, function (attachment) {
            if (attachmentTag.id === attachment.id) {
                attachment.checked = false;
            }
        });
        _.remove($scope.taskEditorViewModel.attachmentTagItems, function (attm) {
            return attachmentTag.id === attm.id;
        });
    };

    $scope.onUploadNewFileBlur = function () {
        handleDocumentInteraction();
    };

    function handleDocumentInteraction() {
        $timeout(function () {
            if ($scope.canCloseAttachmentList) {
                if ($scope.canDisplayList) {
                    $scope.taskEditorViewModel.showAttachmentList = !$scope.taskEditorViewModel.showAttachmentList;
                } else {
                    $scope.taskEditorViewModel.showAttachmentList = false;
                    removeListeners();
                }
                $scope.canDisplayList = false;
            }
            $scope.canCloseAttachmentList = true;
        }, 0);
    }

    function addListeners() {
        $document.on('click', handleDocumentInteraction);
    }

    function removeListeners() {
        $document.off('click', handleDocumentInteraction);
    }

    function loadSubmissionAttachmentList() {
        if($scope.isAgent()) {
            collaborationMediator.loadSharedSubmissionAttachments($stateParams.submissionId).then(function (submissionAttachmentList) {
                $scope.taskEditorViewModel.attachmentSummaries = submissionAttachmentList;
            });
        } else {
            collaborationMediator.loadSubmissionAttachments($stateParams.submissionId).then(function (submissionAttachmentList) {
                $scope.taskEditorViewModel.attachmentSummaries = submissionAttachmentList;
            });
        }
    }

    loadSubmissionAttachmentList();

    resetTaskViewModel();
};

angular.module('gw-um-submission')
    .controller('collaborationTaskEditorController', CollaborationTaskEditorController);
